(function () {
  'use strict';

  if (
    window.EACompare &&
    window.EACompare.__eaCompareEngine === true
  ) {
    return;
  }

  /*
   * ============================================================
   * CONFIGURAÇÃO
   * ============================================================
   */

  const CONFIG =
    window.EA_COMPARE_CONFIG || {};

  const STORAGE_KEY =
    'ea-compare-list';

  const MAX_PRODUCTS =
    3;

  const COMPARE_PAGE_PATH =
    typeof CONFIG.comparePage === 'string' &&
    CONFIG.comparePage.trim()
      ? CONFIG.comparePage.trim()
      : '/pages/comparacao-de-equipamentos';

  /*
   * Se por algum motivo a coleção não estiver configurada
   * no EA - Global, usamos a Home como fallback seguro.
   *
   * Normalmente este valor virá da coleção escolhida
   * no Editor do Tema.
   */
  const EMPTY_COMPARE_REDIRECT_PATH =
    typeof CONFIG.emptyRedirect === 'string' &&
    CONFIG.emptyRedirect.trim()
      ? CONFIG.emptyRedirect.trim()
      : '/';

  const MODAL_ID =
    'ea-compare-modal';

  const STYLE_ID =
    'ea-compare-styles';

  const LAUNCHER_ID =
    'ea-compare-launcher';

  let previousFocusedElement =
    null;

  /*
   * ============================================================
   * HELPERS DE URL
   * ============================================================
   */

  function normalizePath(path) {
    if (!path) {
      return '/';
    }

    const normalized =
      path.replace(/\/+$/, '');

    return normalized || '/';
  }

  function isComparePage() {
    return (
      normalizePath(
        window.location.pathname
      ) ===
      normalizePath(
        COMPARE_PAGE_PATH
      )
    );
  }

  /*
   * ============================================================
   * STORAGE
   * ============================================================
   */

  function getList() {
    try {
      const stored =
        localStorage.getItem(
          STORAGE_KEY
        );

      if (!stored) {
        return [];
      }

      const parsed =
        JSON.parse(stored);

      return Array.isArray(parsed)
        ? parsed
        : [];
    } catch (error) {
      console.warn(
        'EA Compare: não foi possível ler a comparação.',
        error
      );

      return [];
    }
  }

  function dispatchChange(list) {
    window.dispatchEvent(
      new CustomEvent(
        'ea:compare:change',
        {
          detail: {
            list: list
          }
        }
      )
    );
  }

  function saveList(list) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(list)
      );
    } catch (error) {
      console.warn(
        'EA Compare: não foi possível salvar a comparação.',
        error
      );

      return false;
    }

    dispatchChange(list);

    return true;
  }

  /*
   * ============================================================
   * MOTOR
   * ============================================================
   */

  function add(product) {
    const list =
      getList();

    if (
      !product ||
      !product.handle ||
      !product.group
    ) {
      return {
        ok: false,
        reason: 'invalid-product',
        list: list
      };
    }

    if (
      list.some(
        function (item) {
          return (
            item.handle ===
            product.handle
          );
        }
      )
    ) {
      return {
        ok: false,
        reason: 'already-added',
        list: list
      };
    }

    const currentGroup =
      list[0]
        ? list[0].group
        : null;

    /*
     * Grupo incompatível vem antes
     * da validação de limite.
     */
    if (
      currentGroup &&
      currentGroup !==
        product.group
    ) {
      return {
        ok: false,
        reason:
          'different-group',

        currentGroup:
          currentGroup,

        attemptedGroup:
          product.group,

        list: list
      };
    }

    if (
      list.length >=
      MAX_PRODUCTS
    ) {
      return {
        ok: false,
        reason: 'max',
        max: MAX_PRODUCTS,
        list: list
      };
    }

    list.push({
      handle:
        product.handle,

      group:
        product.group
    });

    if (!saveList(list)) {
      return {
        ok: false,
        reason:
          'storage-error',

        list:
          getList()
      };
    }

    return {
      ok: true,
      reason: 'added',
      list: list
    };
  }

  function remove(handle) {
    const list =
      getList();

    const newList =
      list.filter(
        function (item) {
          return (
            item.handle !==
            handle
          );
        }
      );

    if (
      newList.length ===
      list.length
    ) {
      return {
        ok: false,
        reason: 'not-found',
        list: list
      };
    }

    if (!saveList(newList)) {
      return {
        ok: false,
        reason:
          'storage-error',

        list:
          getList()
      };
    }

    return {
      ok: true,
      reason: 'removed',
      list: newList
    };
  }

  function clear() {
    try {
      localStorage.removeItem(
        STORAGE_KEY
      );
    } catch (error) {
      console.warn(
        'EA Compare: não foi possível limpar a comparação.',
        error
      );

      return {
        ok: false,
        reason:
          'storage-error',

        list:
          getList()
      };
    }

    dispatchChange([]);

    return {
      ok: true,
      reason: 'cleared',
      list: []
    };
  }

  function isSelected(handle) {
    return getList().some(
      function (item) {
        return (
          item.handle ===
          handle
        );
      }
    );
  }

  function getCount() {
    return getList().length;
  }

  function getGroup() {
    const list =
      getList();

    return list.length
      ? list[0].group
      : null;
  }

  function toggle(product) {
    if (
      !product ||
      !product.handle
    ) {
      return {
        ok: false,
        reason:
          'invalid-product',

        list:
          getList()
      };
    }

    if (
      isSelected(
        product.handle
      )
    ) {
      return remove(
        product.handle
      );
    }

    return add(product);
  }

  /*
   * ============================================================
   * PÁGINA DE COMPARAÇÃO
   * ============================================================
   */

  function enforceComparePageAccess() {
    if (!isComparePage()) {
      return false;
    }

    /*
     * Existe pelo menos um produto:
     * acesso permitido.
     */
    if (getCount() > 0) {
      return false;
    }

    /*
     * Comparação vazia:
     * envia para a coleção escolhida
     * no EA - Global.
     */
    window.location.replace(
      EMPTY_COMPARE_REDIRECT_PATH
    );

    return true;
  }

  /*
   * ============================================================
   * BOTÕES DE PRODUTO
   * ============================================================
   */

  function updateButtons() {
    const buttons =
      document.querySelectorAll(
        '[data-ea-compare-button]'
      );

    buttons.forEach(
      function (button) {
        const handle =
          button.dataset
            .eaCompareHandle || '';

        const selected =
          handle
            ? isSelected(
                handle
              )
            : false;

        button.setAttribute(
          'aria-pressed',
          selected
            ? 'true'
            : 'false'
        );

        button.classList.toggle(
          'is-selected',
          selected
        );
      }
    );
  }

  /*
   * ============================================================
   * EVENTOS
   * ============================================================
   */

  function dispatchResult(
    result,
    product
  ) {
    window.dispatchEvent(
      new CustomEvent(
        'ea:compare:result',
        {
          detail: {
            result: result,
            product: product
          }
        }
      )
    );
  }

  function dispatchBlocked(
    result,
    product
  ) {
    window.dispatchEvent(
      new CustomEvent(
        'ea:compare:blocked',
        {
          detail: {
            reason:
              result.reason,

            result:
              result,

            product:
              product
          }
        }
      )
    );
  }

  /*
   * ============================================================
   * CSS
   *
   * Visual do launcher ainda provisório.
   * ============================================================
   */

  function ensureStyles() {
    if (
      document.getElementById(
        STYLE_ID
      )
    ) {
      return;
    }

    const style =
      document.createElement(
        'style'
      );

    style.id =
      STYLE_ID;

    style.textContent = `
      body.ea-compare-modal-open {
        overflow: hidden;
      }

      /*
       * LAUNCHER
       */

      #${LAUNCHER_ID}[hidden] {
        display: none !important;
      }

      #${LAUNCHER_ID} {
        position: fixed;
        right: 0;
        top: 50%;
        z-index: 99990;

        transform:
          translateY(-50%);

        display: flex;
        align-items: center;

        min-height: 112px;

        padding:
          14px 10px;

        border:
          1px solid #000000;

        border-right: 0;

        background:
          #ffffff;

        color:
          #000000;

        cursor: pointer;

        font: inherit;

        writing-mode:
          vertical-rl;

        text-orientation:
          mixed;

        gap: 8px;
      }

      #${LAUNCHER_ID}
      .ea-compare-launcher__label {
        font-size: 13px;

        font-weight: 600;

        line-height: 1;

        text-transform:
          uppercase;
      }

      #${LAUNCHER_ID}
      .ea-compare-launcher__count {
        width: 24px;
        height: 24px;

        display: flex;
        align-items: center;
        justify-content: center;

        border:
          1px solid #000000;

        border-radius: 50%;

        background:
          #ffffff;

        color:
          #000000;

        font-size: 12px;

        line-height: 1;

        writing-mode:
          horizontal-tb;
      }

      #${LAUNCHER_ID}:hover {
        background:
          #f3f3f3;
      }

      #${LAUNCHER_ID}:focus-visible {
        outline:
          2px solid #000000;

        outline-offset:
          3px;
      }

      /*
       * MODAL
       */

      #${MODAL_ID}[hidden] {
        display:
          none !important;
      }

      #${MODAL_ID} {
        position: fixed;
        inset: 0;

        z-index:
          999999;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 24px;

        font-family:
          inherit;
      }

      #${MODAL_ID}
      .ea-compare-modal__backdrop {
        position:
          absolute;

        inset: 0;

        background:
          rgba(
            0,
            0,
            0,
            0.56
          );

        opacity: 0;

        transition:
          opacity
          180ms
          ease;
      }

      #${MODAL_ID}
      .ea-compare-modal__dialog {
        position:
          relative;

        z-index: 1;

        width:
          min(
            100%,
            560px
          );

        max-height:
          calc(
            100vh -
            48px
          );

        overflow: auto;

        background:
          #ffffff;

        color:
          #000000;

        border:
          1px solid
          #000000;

        transform:
          translateY(
            12px
          );

        opacity: 0;

        transition:
          opacity
          180ms
          ease,
          transform
          180ms
          ease;

        outline: none;
      }

      #${MODAL_ID}.is-open
      .ea-compare-modal__backdrop {
        opacity: 1;
      }

      #${MODAL_ID}.is-open
      .ea-compare-modal__dialog {
        opacity: 1;

        transform:
          translateY(0);
      }

      #${MODAL_ID}
      .ea-compare-modal__header {
        position:
          relative;

        padding:
          30px
          64px
          24px
          30px;

        border-bottom:
          1px solid
          #000000;
      }

      #${MODAL_ID}
      .ea-compare-modal__title {
        margin: 0;

        font: inherit;

        font-size:
          26px;

        line-height:
          1.05;

        font-weight:
          700;

        text-transform:
          uppercase;

        color:
          #000000;
      }

      #${MODAL_ID}
      .ea-compare-modal__close {
        position:
          absolute;

        top: 18px;
        right: 18px;

        width: 40px;
        height: 40px;

        padding: 0;
        margin: 0;

        border: 0;

        background:
          transparent;

        color:
          #000000;

        cursor:
          pointer;

        font: inherit;

        font-size:
          32px;

        line-height: 1;

        display: flex;
        align-items: center;
        justify-content: center;
      }

      #${MODAL_ID}
      .ea-compare-modal__close:hover {
        opacity: 0.55;
      }

      #${MODAL_ID}
      .ea-compare-modal__body {
        padding: 30px;
      }

      #${MODAL_ID}
      .ea-compare-modal__message {
        margin: 0;

        font: inherit;

        font-size:
          17px;

        line-height:
          1.45;

        color:
          #000000;
      }

      #${MODAL_ID}
      .ea-compare-modal__footer {
        border-top:
          1px solid
          #000000;
      }

      #${MODAL_ID}
      .ea-compare-modal__action {
        appearance:
          none;

        width: 100%;

        min-height:
          64px;

        padding:
          16px
          24px;

        border: 0;

        background:
          #000000;

        color:
          #ffffff;

        cursor:
          pointer;

        font: inherit;

        font-size:
          15px;

        font-weight:
          600;

        text-transform:
          uppercase;
      }

      #${MODAL_ID}
      .ea-compare-modal__action:hover {
        background:
          #222222;
      }

      #${MODAL_ID}
      button:focus-visible {
        outline:
          2px solid
          #000000;

        outline-offset:
          3px;
      }

      @media (
        max-width:
        576px
      ) {
        #${MODAL_ID} {
          padding: 12px;
        }

        #${MODAL_ID}
        .ea-compare-modal__dialog {
          width: 100%;

          max-height:
            calc(
              100vh -
              24px
            );
        }

        #${MODAL_ID}
        .ea-compare-modal__header {
          padding:
            24px
            58px
            20px
            22px;
        }

        #${MODAL_ID}
        .ea-compare-modal__title {
          font-size:
            22px;
        }

        #${MODAL_ID}
        .ea-compare-modal__body {
          padding: 22px;
        }

        #${MODAL_ID}
        .ea-compare-modal__message {
          font-size:
            16px;
        }

        #${LAUNCHER_ID} {
          min-height:
            96px;

          padding:
            12px
            8px;
        }
      }

      @media (
        prefers-reduced-motion:
        reduce
      ) {
        #${MODAL_ID}
        .ea-compare-modal__backdrop,

        #${MODAL_ID}
        .ea-compare-modal__dialog {
          transition:
            none;
        }
      }
    `;

    document.head.appendChild(
      style
    );
  }

  /*
   * ============================================================
   * LAUNCHER
   * ============================================================
   */

  function ensureLauncher() {
    let launcher =
      document.getElementById(
        LAUNCHER_ID
      );

    if (launcher) {
      return launcher;
    }

    ensureStyles();

    launcher =
      document.createElement(
        'button'
      );

    launcher.id =
      LAUNCHER_ID;

    launcher.type =
      'button';

    launcher.hidden =
      true;

    launcher.setAttribute(
      'aria-label',
      'Abrir comparação'
    );

    launcher.innerHTML = `
      <span
        class="ea-compare-launcher__count"
        aria-hidden="true"
      >
        0
      </span>

      <span
        class="ea-compare-launcher__label"
      >
        Comparar
      </span>
    `;

    document.body.appendChild(
      launcher
    );

    launcher.addEventListener(
      'click',
      function () {
        const list =
          getList();

        if (!list.length) {
          return;
        }

        /*
         * Mantemos o evento público.
         * Pode ser útil para integrações futuras.
         */
        window.dispatchEvent(
          new CustomEvent(
            'ea:compare:launcher',
            {
              detail: {
                list: list,

                count:
                  list.length,

                group:
                  getGroup()
              }
            }
          )
        );

        /*
         * Agora o launcher navega para
         * a página selecionada no EA - Global.
         */
        window.location.assign(
          COMPARE_PAGE_PATH
        );
      }
    );

    return launcher;
  }

  function updateLauncher() {
    const launcher =
      ensureLauncher();

    const count =
      getCount();

    const counter =
      launcher.querySelector(
        '.ea-compare-launcher__count'
      );

    if (counter) {
      counter.textContent =
        String(count);
    }

    launcher.setAttribute(
      'aria-label',
      count === 1
        ? 'Abrir comparação com 1 equipamento'
        : 'Abrir comparação com ' +
            count +
            ' equipamentos'
    );

    launcher.hidden =
      count === 0;
  }

  /*
   * ============================================================
   * MODAL
   * ============================================================
   */

  function ensureModal() {
    let modal =
      document.getElementById(
        MODAL_ID
      );

    if (modal) {
      return modal;
    }

    ensureStyles();

    modal =
      document.createElement(
        'div'
      );

    modal.id =
      MODAL_ID;

    modal.hidden =
      true;

    modal.innerHTML = `
      <div
        class="ea-compare-modal__backdrop"
        data-ea-compare-modal-close
      ></div>

      <div
        class="ea-compare-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ea-compare-modal-title"
        aria-describedby="ea-compare-modal-message"
        tabindex="-1"
      >
        <div
          class="ea-compare-modal__header"
        >
          <h2
            id="ea-compare-modal-title"
            class="ea-compare-modal__title"
          ></h2>

          <button
            type="button"
            class="ea-compare-modal__close"
            aria-label="Fechar"
            data-ea-compare-modal-close
          >
            &times;
          </button>
        </div>

        <div
          class="ea-compare-modal__body"
        >
          <p
            id="ea-compare-modal-message"
            class="ea-compare-modal__message"
          ></p>
        </div>

        <div
          class="ea-compare-modal__footer"
        >
          <button
            type="button"
            class="ea-compare-modal__action"
            data-ea-compare-modal-close
          >
            Entendi
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(
      modal
    );

    modal.addEventListener(
      'click',
      function (event) {
        const closeTrigger =
          event.target.closest(
            '[data-ea-compare-modal-close]'
          );

        if (!closeTrigger) {
          return;
        }

        closeModal();
      }
    );

    return modal;
  }

  function getBlockedMessage(reason) {
    if (
      reason ===
      'different-group'
    ) {
      return {
        title:
          'Comparação incompatível',

        message:
          'Para comparar equipamentos, selecione itens da mesma categoria. Remova os equipamentos atuais da comparação antes de adicionar um equipamento de outra categoria.'
      };
    }

    if (
      reason === 'max'
    ) {
      return {
        title:
          'Limite de comparação',

        message:
          'Você pode comparar até 3 equipamentos por vez. Remova um deles da comparação antes de adicionar outro.'
      };
    }

    if (
      reason ===
      'storage-error'
    ) {
      return {
        title:
          'Não foi possível atualizar',

        message:
          'Não foi possível atualizar sua comparação. Recarregue a página e tente novamente.'
      };
    }

    return {
      title:
        'Não foi possível comparar',

      message:
        'Não foi possível adicionar este equipamento à comparação.'
    };
  }

  function openBlockedModal(detail) {
    const modal =
      ensureModal();

    const dialog =
      modal.querySelector(
        '.ea-compare-modal__dialog'
      );

    const title =
      modal.querySelector(
        '.ea-compare-modal__title'
      );

    const message =
      modal.querySelector(
        '.ea-compare-modal__message'
      );

    const content =
      getBlockedMessage(
        detail.reason
      );

    previousFocusedElement =
      document.activeElement;

    title.textContent =
      content.title;

    message.textContent =
      content.message;

    modal.hidden =
      false;

    document.body.classList.add(
      'ea-compare-modal-open'
    );

    requestAnimationFrame(
      function () {
        modal.classList.add(
          'is-open'
        );

        dialog.focus();
      }
    );
  }

  function closeModal() {
    const modal =
      document.getElementById(
        MODAL_ID
      );

    if (
      !modal ||
      modal.hidden
    ) {
      return;
    }

    modal.classList.remove(
      'is-open'
    );

    document.body.classList.remove(
      'ea-compare-modal-open'
    );

    window.setTimeout(
      function () {
        modal.hidden =
          true;

        if (
          previousFocusedElement &&
          typeof
            previousFocusedElement
              .focus ===
            'function' &&
          document.contains(
            previousFocusedElement
          )
        ) {
          previousFocusedElement
            .focus();
        }

        previousFocusedElement =
          null;
      },
      190
    );
  }

  function handleModalKeydown(event) {
    const modal =
      document.getElementById(
        MODAL_ID
      );

    if (
      !modal ||
      modal.hidden
    ) {
      return;
    }

    if (
      event.key ===
      'Escape'
    ) {
      event.preventDefault();

      closeModal();

      return;
    }

    if (
      event.key !==
      'Tab'
    ) {
      return;
    }

    const focusable =
      modal.querySelectorAll(
        [
          'button:not([disabled])',
          '[href]',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',')
      );

    if (!focusable.length) {
      return;
    }

    const first =
      focusable[0];

    const last =
      focusable[
        focusable.length - 1
      ];

    if (
      event.shiftKey &&
      document.activeElement ===
        first
    ) {
      event.preventDefault();

      last.focus();

      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement ===
        last
    ) {
      event.preventDefault();

      first.focus();
    }
  }

  /*
   * ============================================================
   * CLIQUE NO BOTÃO COMPARAR
   * ============================================================
   */

  function handleCompareClick(event) {
    const button =
      event.target.closest(
        '[data-ea-compare-button]'
      );

    if (!button) {
      return;
    }

    event.preventDefault();

    const product = {
      handle:
        button.dataset
          .eaCompareHandle || '',

      group:
        button.dataset
          .eaCompareGroup || ''
    };

    const result =
      toggle(product);

    updateButtons();
    updateLauncher();

    dispatchResult(
      result,
      product
    );

    if (
      !result.ok &&
      (
        result.reason ===
          'different-group' ||

        result.reason ===
          'max' ||

        result.reason ===
          'storage-error'
      )
    ) {
      dispatchBlocked(
        result,
        product
      );
    }
  }

  /*
   * ============================================================
   * EVENT LISTENERS
   * ============================================================
   */

  document.addEventListener(
    'click',
    handleCompareClick
  );

  document.addEventListener(
    'keydown',
    handleModalKeydown
  );

  window.addEventListener(
    'ea:compare:change',
    function () {
      updateButtons();
      updateLauncher();

      /*
       * Se o último produto for removido
       * enquanto o usuário estiver dentro
       * da página de comparação,
       * redirecionamos para a coleção
       * escolhida no EA - Global.
       */
      if (
        isComparePage() &&
        getCount() === 0
      ) {
        window.location.replace(
          EMPTY_COMPARE_REDIRECT_PATH
        );
      }
    }
  );

  window.addEventListener(
    'ea:compare:blocked',
    function (event) {
      openBlockedModal(
        event.detail
      );
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      updateButtons();
      updateLauncher();
    }
  );

  /*
   * ============================================================
   * INITIALIZE
   * ============================================================
   */

  function initialize() {
    /*
     * Antes de montar qualquer interface,
     * verificamos se a página de comparação
     * pode ser acessada.
     */
    if (
      enforceComparePageAccess()
    ) {
      return;
    }

    ensureStyles();
    ensureLauncher();

    updateButtons();
    updateLauncher();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }

  /*
   * ============================================================
   * API PÚBLICA
   * ============================================================
   */

  window.EACompare = {
    __eaCompareEngine:
      true,

    version:
      '0.6.1',

    storageKey:
      STORAGE_KEY,

    maxProducts:
      MAX_PRODUCTS,

    comparePage:
      COMPARE_PAGE_PATH,

    emptyRedirect:
      EMPTY_COMPARE_REDIRECT_PATH,

    getList:
      getList,

    add:
      add,

    remove:
      remove,

    clear:
      clear,

    toggle:
      toggle,

    isSelected:
      isSelected,

    getCount:
      getCount,

    getGroup:
      getGroup,

    updateButtons:
      updateButtons,

    updateLauncher:
      updateLauncher,

    closeModal:
      closeModal
  };

  console.log(
    'EA Compare engine loaded'
  );
})();